import { getRuntimeConfig } from '../config/runtime-config';
import { getCurrentToken } from './token-store';

function isLocalhostApi(apiBaseUrl: string): boolean {
  try {
    const api = new URL(apiBaseUrl);
    return api.hostname === 'localhost' || api.hostname === '127.0.0.1';
  } catch {
    return false;
  }
}

/**
 * Returns a bearer token only for non-local demo/production deployments.
 *
 * Local demo mode uses the Zenoh webserver on :18000, whose CORS policy does
 * not allow the Authorization header. In that mode the SPA must rely on the
 * browser's same-origin/session behavior for the mock stack and omit Bearer
 * headers entirely.
 */
export function getRequestBearerToken(): string | null {
  const cfg = getRuntimeConfig();
  if (cfg.authMode === 'mock' && isLocalhostApi(cfg.apiBaseUrl)) {
    return null;
  }
  return getCurrentToken();
}
